import { render, staticRenderFns } from "./dialog-fee-sign.vue?vue&type=template&id=0be6d88b&scoped=true&"
import script from "./dialog-fee-sign.vue?vue&type=script&lang=js&"
export * from "./dialog-fee-sign.vue?vue&type=script&lang=js&"
import style0 from "./dialog-fee-sign.vue?vue&type=style&index=0&id=0be6d88b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6d88b",
  null
  
)

export default component.exports